import { ProductType } from 'module/api/account/types';
import { LoginWithSessionToken } from 'module/authentication/components/login-with-session-token';
import { App } from 'App';
import { createBrowserRouter, redirect, RouteObject } from 'react-router-dom';
import { Home } from 'components/organisms/home/home';
import { LoginCallback } from 'components/organisms/login-callback';
import { Logout } from 'components/organisms/logout';
import { AccountActivatePage } from 'components/pages/account-activate';
import { ForgotPasswordPage } from 'components/pages/forgot-password';
import { ResetPasswordPage } from 'components/pages/reset-password';
import { accountsRoutes } from './accounts-routes';
import { agentBuilderRoutes } from './agent-builder-routes';
import { allSignalsRoutes } from './all-signals-routes';
import { knowledgeBaseRoutes } from './knowledge-base';
import { Login } from './login';
import { ProtectedRoutes } from './protected-routes';
import { NonProtectedRoutesLayout } from './route-navigators';
import { ROUTE_PATHS } from './route-paths';
import { SecureRoute } from './secure-route';
import { settingsRoutes } from './settings-route';
import { signalAgentsRoutes } from './signal-agents-routes';
import { templatesRoutes } from './templates-routes';

const nonProtectedRoutes: RouteObject[] = [
  {
    path: ROUTE_PATHS.LOGIN_CALLBACK,
    element: <LoginCallback />,
  },
  {
    path: ROUTE_PATHS.LOGIN,
    element: <Login />,
  },
  {
    path: ROUTE_PATHS.LOGOUT,
    element: <Logout />,
  },
  {
    path: ROUTE_PATHS.LOGIN_SESSION,
    element: <LoginWithSessionToken />,
  },
  {
    path: ROUTE_PATHS.ACTIVATE,
    element: <AccountActivatePage productType={ProductType.Signals} />,
  },
  {
    path: ROUTE_PATHS.FORGOT_PASSWORD,
    element: <ForgotPasswordPage />,
  },
  {
    path: ROUTE_PATHS.SET_PASSWORD,
    element: <ResetPasswordPage />,
  },
];

const homeRoutes: RouteObject = {
  path: ROUTE_PATHS.HOME,
  loader: () => {
    return redirect(ROUTE_PATHS.ACCOUNTS);
  },
  element: (
    <SecureRoute>
      <Home />
    </SecureRoute>
  ),
};

const routes: RouteObject[] = [
  {
    path: ROUTE_PATHS.ROOT,
    element: <App />,
    children: [
      {
        element: <ProtectedRoutes />,
        children: [
          homeRoutes,
          accountsRoutes,
          templatesRoutes,
          settingsRoutes,
          allSignalsRoutes,
          knowledgeBaseRoutes,
          ...agentBuilderRoutes,
          ...signalAgentsRoutes,
        ],
      },
      {
        element: <NonProtectedRoutesLayout />,
        caseSensitive: true,
        children: nonProtectedRoutes,
      },
      { path: ROUTE_PATHS.MATCH_ALL, element: <div>Not Found</div> },
    ],
  },
];

export const router = createBrowserRouter(routes);
